import { RELATIVE_ALL_TIME } from "views/Constants";
import { isTypeRelativeWithEnd, isTypeRelativeWithStartOnly } from "views/typeGuards/timeRange";
const isAllMessagesRange = (timeRange) => isTypeRelativeWithEnd(timeRange) && timeRange.from === RELATIVE_ALL_TIME || isTypeRelativeWithStartOnly(timeRange) && timeRange.range === RELATIVE_ALL_TIME;
export default isAllMessagesRange;
